<template>
    <div>
        <ul class="list">
            <li v-for="(item,  index) in list" v-bind:key="index">
                <div class="left">
                    <van-checkbox v-model="item.checked"></van-checkbox>
                    <img :src="imageURL" alt="">
                </div>
                <div @click="goConfirm(item.RECORD_ID)" class="rightbox">
                    <div class="right">
                        <span>{{item.TYPE}}</span>
                        <div class="gray">{{item.NAME}}<span class="num">{{item.PHONE_NUM}}</span></div>
                    </div>
                    <div class="items">
                        <ul>
                            <li>
                                <span>【基础项目】</span><span class="num">x{{item.BASIC}}</span>
                            </li>
                            <li>
                                <span>【新增项目】</span><span class="num">x{{item.ADDITEMS}}</span>
                            </li>
                        </ul>
                    </div>
                    <div class="total">
                        <span>小计：</span><b>¥{{item.PRICE}}</b>
                    </div>
                </div>
                <div class="btns">
                    <button @click="onClose(item.RECORD_ID)" class="tuikuan">删除</button>
                    <div class="empty"></div>
                </div>
                <!-- <van-cell-swipe :right-width="65" :left-width="65">
                                                                <span slot="left">选择</span>
                                                                <van-cell-group>
                                                                    <van-cell title="单元格" value="内容" />
                                                                </van-cell-group>
                                                                <span slot="right">删除</span>
                                                            </van-cell-swipe> -->
            </li>
        </ul>
        <div class="buy">
            <div class="price">
                <van-checkbox @click.native='change' v-model="allchecked">全选</van-checkbox>
                <span class="c3">合计：</span><b>¥{{totalPrice}}</b>
            </div>
            <button class="btnbuy" @click="submit">结算（{{num}}）</button>
        </div>
    </div>
</template>

<script>
    import api from '@/fetch/api';
    import {
        CellSwipe,
        Dialog,
        Toast
    } from 'vant';
    import {
        mapGetters
    } from 'vuex';
    export default {
        data() {
            return {
                imageURL: 'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1528431608002&di=00ad850a978b02b196e003a24b19c6c2&imgtype=0&src=http%3A%2F%2Fimg.mp.itc.cn%2Fupload%2F20170413%2F168a43e2babc420d9fe640a2286cb7c6_th.jpeg',
                list: [],
                allchecked: false,
                num: 0,
                totalPrice: 0
            }
        },
        created() {
            sessionStorage.removeItem('records');
            this.bind();
        },
        computed: {
            ...mapGetters(["loginStatus", "userInfo"]),
        },
        watch: {
            list: {
                handler() {
                    this.num = 0;
                    this.totalPrice = 0;
                    this.allchecked = true;
                    this.list.forEach(n => {
                        if (!n.checked) {
                            this.allchecked = false;
                        } else {
                            this.num++;
                            this.totalPrice += parseFloat(n.PRICE);
                        }
                    })
                },
                deep: true // 深度监视
            }
        },
        methods: {
            change() {
                this.list.forEach(n => {
                    n.checked = this.allchecked;
                })
            },
            submit() {
                let ids = this.list.filter(p => p.checked == true).map(function(v) {
                    return v.RECORD_ID;
                });
                let selected = ids.length > 0;
                if (selected) {
                    let items = this.list.filter(p => p.checked == true).map(function(v) {
                        return {
                            PHONE_NUM: v.PHONE_NUM,
                            PRICE: v.PRICE,
                            RECORD_ID: v.RECORD_ID,
                            TYPE: v.TYPE,
                            NAME: v.NAME
                        };
                    });
                    sessionStorage.setItem('records', JSON.stringify(items));
                    //提交订单数据
                    this.$router.push('/user/confimOrder/' + ids);
                } else {}
            },
            itemchange() {
                this.num = 0;
                this.totalPrice = 0;
                this.list.forEach(n => {
                    if (!n.checked) {
                        this.allchecked = false;
                    } else {
                        this.num++;
                        this.totalPrice += parseFloat(n.PRICE);
                    }
                })
            },
            goConfirm(orderID) {
                let item = this.list.find(p => p.RECORD_ID == orderID);
                let selItem = {
                    PHONE_NUM: item.PHONE_NUM,
                    PRICE: item.PRICE,
                    RECORD_ID: item.RECORD_ID,
                    TYPE: item.TYPE,
                    NAME: item.NAME
                };
                console.log(selItem);
                sessionStorage.setItem('records', JSON.stringify(selItem));
                this.$router.push('/user/confimOrder/' + orderID);
            },
            bind() {
                api.goShoppingCart(this.userInfo.CUSTOMER_ID).then(re => {
                    console.log(re);
                    let list = re.data.CartList;
                    if (list.length > 0) {
                        this.list = [];
                        list.forEach(el => {
                            this.list.push({
                                PHONE_NUM: el.PHONE_NUM,
                                PRICE: el.PRICE,
                                SHOPPING_TIME: el.SHOPPING_TIME,
                                ADDITEMS: el.ADDITEMS,
                                RECORD_ID: el.RECORD_ID,
                                TYPE: (el.TYPE == '固定套餐' ? el.COMBO_NAME : el.TYPE),
                                BASIC: el.BASIC,
                                NAME: el.NAME,
                                checked: false
                            })
                        });
                    } else {
                        this.$router.replace('/shoplist')
                    }
                })
            },
            onClose(RECORD_ID) {
                Dialog.confirm({
                    title: '确认删除',
                    message: '确定从购物车移除吗？'
                }).then(() => {
                    api.deleteOrder(RECORD_ID, this.userInfo.CUSTOMER_ID).then(re => {
                        this.bind();
                    });
                }).catch(() => {
                    // on cancel
                });
            }
        },
    }
</script>

<style scoped lang='less'>
    .van-checkbox {
        display: inline;
    }
    .buy {
        font-family: "Microsoft YaHei" !important;
        padding-left: 1em;
        .btnbuy {
            padding: 0 1.2em;
        }
        .price {
            span {
                display: inline;
                font-size: 1rem !important;
                margin-left: 2em;
            }
        }
    }
    .gray {
        color: #BCBCBC;
    }
    .num {
        position: absolute;
        right: 1em;
    }
    .list {
        font-family: "Microsoft YaHei" !important;
        padding-bottom: 3em;
        .rightbox {
            padding: 0 1em 0 9em;
        }
        .right {
            // margin-top: 0.5em;
            font-size: 1rem;
            >span {
                display: block;
                line-height: 2em;
            }
        }
        .total {
            text-align: right;
            font-size: 0.8rem;
            margin-top: 0.5em;
            b {
                font-size: 1rem;
                color: #FF7C3E;
            }
        }
        .items {
            margin-top: 0.8em;
            li {
                position: relative;
                font-size: 0.8rem;
                .num {
                    right: 0;
                }
            }
        }
        >li {
            // height: 8.5em;
            height: 11em;
            position: relative;
            padding: 0.2em 0 0.2em 0em;
            border-bottom: 5px solid #eee;
        }
        .left {
            position: absolute;
            left: 1em;
            top: 1em;
            .van-checkbox {
                position: absolute;
                top: 2.5em;
                left: 0;
            }
            img {
                width: 5em;
                height: 4em;
                position: absolute;
                left: 2em;
                top: 0em;
            }
        }
        .btns {
            position: absolute;
            bottom: 0;
            clear: both;
            text-align: right;
            font-size: 0.8rem;
            padding-top: 0.5em;
            width: 100%;
            left: 0;
            border-top: 1px solid #eee;
            button {
                border-radius: 10px;
                border: 1px solid #ccc;
                color: #666;
                width: 5rem;
                text-align: center;
                line-height: 1.8em;
                margin-bottom: 0.4em;
                background: #fff;
                margin-left: 1em;
            }
            .blue {
                color: #99C51D;
                border-color: #99C51D;
            }
            .red {
                color: #ff681d;
                border-color: #ff681d;
            }
            .empty {
                display: inline-block;
                width: 1em;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/shopcart.vue